export function isCustomProficiency(proficiency) {
    return ['proficiency', 'expertise'].includes(proficiency.proficiencyLevel);
}
